module.exports = __webpack_public_path__ + "static/media/file-gif.982445d0.svg";